export default __webpack_public_path__ + "static/media/twitter-icon.76f21dcc.svg";